import { useQuery } from "@tanstack/react-query";
import { historyService } from "../services/historyService";

// Query keys for consistent cache management
export const historyKeys = {
  all: ["history"],
  actionLog: (params) => [...historyKeys.all, "actionLog", params],
  deviceHistory: (deviceId, params) => [
    ...historyKeys.all,
    "device",
    deviceId,
    params,
  ],
};

// Custom hooks for history data
export const useActionLogHistory = (params = {}, options = {}) => {
  return useQuery({
    queryKey: historyKeys.actionLog(params),
    queryFn: () => historyService.getActionLogHistory(params),
    ...options,
  });
};

export const useDeviceHistoryData = (deviceId, params = {}, options = {}) => {
  return useQuery({
    queryKey: historyKeys.deviceHistory(deviceId, params),
    queryFn: () => historyService.getDeviceHistory(deviceId, params),
    enabled: !!deviceId,
    ...options,
  });
};
